<template>
  <div>
    <Header></Header>
    <Header1></Header1>
    <ProductList></ProductList>
  </div>
</template>
<script>
import Header from "./header.vue";
import Header1 from "./header1.vue";
import ProductList from "./productList.vue";
export default {
  data() {
    return {};
  },
  components: {
    Header,
    Header1,
    ProductList,
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
</style>    